export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <rect x="1" y="1" width="46" height="46" rx="11" fill="#0A192F" />
    <path d="M24 6.5 41.5 24 24 41.5 6.5 24Z" stroke="#C5A880" strokeWidth="1.4" />
    <path d="M15 17h10M15 24h7.5M15 31h10M15 17v14" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M28.5 20h7.5M28.5 26.5h5.5M28.5 33h7.5M28.5 20v13" stroke="#C5A880" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

export default function Logo({ light = false, compact = false }) {
  return (
    <span className="flex shrink-0 items-center gap-3 whitespace-nowrap" data-testid="nav-brand-logo">
      <LogoMark className="h-10 w-10 shrink-0" />
      <span className="flex flex-col leading-none">
        <span
          className={`font-display text-lg font-extrabold tracking-tight sm:text-xl ${
            light ? "text-white" : "text-navy"
          }`}
        >
          EVOLVE ELITE
        </span>
        {!compact && (
          <span
            className={`mt-1 font-mono text-[8px] font-semibold uppercase tracking-[0.34em] ${
              light ? "text-gold" : "text-amber-600"
            }`}
          >
            Comprehensive Consultancy
          </span>
        )}
      </span>
    </span>
  );
}
